import { ComponentChildren, Fragment, FunctionalComponent, h } from "preact";
import { useEffect } from "preact/hooks";

import { setMetaTag } from "utils/dom/pageMeta";

const SITE_TITLE = "TELEPHONE";
const DEFAULT_IMAGE = "/assets/img/share-banner.png";
const DEFAULT_DESCRIPTION =
  "TELEPHONE is a global art project based on the children’s game Telephone.";

interface Props {
  title: string;
  children: ComponentChildren;
  description?: string;
  image?: string;
}

const Page: FunctionalComponent<Props> = (props: Props) => {
  useEffect(() => {
    const title = `${props.title} | ${SITE_TITLE}`;
    // Sets the page's meta in the document head.
    document.title = title;
    setMetaTag("name", "description", props.description ?? DEFAULT_DESCRIPTION);
    setMetaTag(
      "property",
      "og:description",
      props.description ?? DEFAULT_DESCRIPTION
    );
    setMetaTag("property", "og:title", title);
    setMetaTag("property", "og:type", "website");
    if (typeof window !== "undefined") {
      setMetaTag("property", "og:url", window.location.toString());
    }
    setMetaTag("property", "og:image", props.image ?? DEFAULT_IMAGE);

    // Make sure when a new page loads, the scrollTop is reset.
    window.scrollTo({ top: 0 });

    return (): void => {
      // Resets the document head to the defaults.
      document.title = SITE_TITLE;
      setMetaTag("name", "description", DEFAULT_DESCRIPTION);
      setMetaTag("property", "og:description", DEFAULT_DESCRIPTION);
      setMetaTag("property", "og:title", SITE_TITLE);
      setMetaTag("property", "og:type", "website");
      if (typeof window !== "undefined") {
        setMetaTag("property", "og:url", window.location.toString());
      }
      setMetaTag("property", "og:image", DEFAULT_IMAGE);
    };
  }, []);
  return <Fragment>{props.children}</Fragment>;
};

export default Page;
